import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Breadcrumbs, Typography, Link } from "@mui/material";
import CoreSpinner from "../../../../../app/core/components/CoreSpinner/CoreSpinner";
import { FOLDER_NUMBER } from "../../../../../utils/constants/tables";
import CoreTable from "../../../../../app/core/components/CoreTable/CoreTable";
import { t } from "i18next";
import CoreStatus from "../../../../../app/core/components/CoreStatus/CoreStatus";
import { formattaDataOraIta } from "../../../../../utils/functions/date-utils";
import {
  useGetDocumentsDataQuery,
  useGetSingleDocumentIdQuery,
} from "../../../../api/admin/gestisciDocumentiApi";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import CoreModal from "../../../../../app/core/components/CoreModal/CoreModal";
import SingleDocumentPage from "../../../../common/SingleDocumentPage/SingleDocumentPage";
import { useSelector } from "react-redux";
import { useGetDocumentsFolderQuery } from "../../../../api/admin/adminFolders";
import CoreButtonHoverIcon from "../../../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";

const FolderExpensecat = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  const standardFolder = location.state.catId;
  const customFolder = location.state.folderId;

  const [rows, setRows] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [listIdDocs, setListIdDocs] = useState(null);
  const [get, setGet] = useState();
  const [isSingleDocumentModalOpen, setIsSingleDocumentModalOpen] =
    useState(false);
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: FOLDER_NUMBER,
  });

  const columns = [
    [t("Name")],
    [t("Status")],
    [t("Uploaded")],
    [t("Category")],
  ];

  const { data: getDocumentList, isLoading } = useGetDocumentsDataQuery(
    {
      page,
      query: "",
      userFilter: location.state.user.id,
      filter: {
        mainCategoryId: standardFolder,
        subCategoryId: "",
        studioId: "",
        adminId: "",
        status: "",
        companyId: "",
        practiceId: "",
        dateFrom: "",
        dateTo: "",
        referenceYear: "",
      },
    },
    {
      skip: !standardFolder,
    }
  );
  const { data: getDocumentsFolder } = useGetDocumentsFolderQuery(
    {
      page,
      folderId: customFolder,
    },
    {
      skip: !customFolder,
    }
  );

  const { data: singleDoc, isLoading: loadingDoc } =
    useGetSingleDocumentIdQuery(selectedDoc, {
      skip: !selectedDoc,
    });

  useEffect(() => {
    if (location && location.state && location.state.catId) {
      setGet(getDocumentList);
    }
    if (location && location.state && location.state.folderId) {
      setGet(getDocumentsFolder);
    }
  }, [location, getDocumentList, getDocumentsFolder]);

  useEffect(() => {
    if (get) {
      setListIdDocs(get?.Data?.items.map((el) => el.id));
    }
  }, [get, customFolder]);

  useEffect(() => {
    if (get) {
      const dataDoc = get?.Data?.items.map((el) => ({
        Id: el.id,
        [t("Name")]: el.name,
        [t("Status")]: <CoreStatus status={el.status} />,
        [t("Uploaded")]: formattaDataOraIta(el.createdAt),
        [t("Category")]: el.categoryName,
      }));
      setRows(dataDoc);
    }
  }, [get, customFolder]);

  const closeModal = () => {
    setIsSingleDocumentModalOpen(false);
  };

  const handleOpenSingleDoc = (doc) => {
    setSelectedDoc(doc);
    setIsSingleDocumentModalOpen(true);
  };

  const handleOpenDocumentsUser = () => {
    navigate("archivio", {
      state: {
        user: { id: location.state.user.id, name: location.state.user.name },
        folderId: customFolder,
      },
    });
  };

  const actions = [
    {
      icon: <SearchRoundedIcon />,
      onClick: (e) => handleOpenSingleDoc(e.Id),
      tooltip: t("Detail"),
    },
  ];

  if (!location || isLoading) {
    return <CoreSpinner />;
  }

  return (
    <div>
      <div className=" w-full flex items-center space-x-20 ">
        <h2>{location.state.user.name}</h2>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            underline="hover"
            color="inherit"
            className="cursor-pointer"
            onClick={() => navigate(-2)}
          >
            {t("Folders")}
          </Link>
          <Link
            underline="hover"
            color="inherit"
            className="cursor-pointer"
            onClick={() => navigate(-1)}
          >
            {t("MacroCategory")}
          </Link>
          <Typography className="font-semibold " sx={{ color: colorPrimary }}>
            {t("Documents")}
          </Typography>
        </Breadcrumbs>
      </div>
      {customFolder && (
        <CoreButtonHoverIcon
          onClick={handleOpenDocumentsUser}
          className="text-blue-500 m-1 flex flex-row space-x-2 border"
          testo={t("Documents")}
          icon={<FolderRoundedIcon className={`fill-blue-500`} />}
        />
      )}

      <CoreTable
        button
        actions={actions}
        rows={rows}
        columns={columns}
        page={page}
        setPage={setPage}
        totalPages={Math.ceil(get?.Data?.count / FOLDER_NUMBER) || 1}
      />
      <CoreModal
        width={"100%"}
        height={"100%"}
        state={isSingleDocumentModalOpen}
        disableClose={true}
        component={
          <SingleDocumentPage
            document={singleDoc?.Data}
            closeModal={closeModal}
            documents={listIdDocs}
            onOpenDoc={handleOpenSingleDoc}
          />
        }
      />
    </div>
  );
};

export default FolderExpensecat;
